import { makeStyles } from '@material-ui/styles';

import { MainButton, Text, ArrowFull, Theme } from '@bizzabo/design-system';

import cn from 'clsx';

interface MeetMainButtonProps {
    isMeetBtnDisabled: boolean;
    shouldUseDropdown: boolean;
    handleMeetButtonClick: () => void;
}

const MeetMainButton: React.FC<MeetMainButtonProps> = ({
    isMeetBtnDisabled,
    shouldUseDropdown,
    handleMeetButtonClick,
}) => {
    const classes = useStyles();

    return (
        <MainButton
            variant="fill"
            size="large"
            className={cn(classes.meetButton, { [classes.disabled]: isMeetBtnDisabled })}
            onClick={handleMeetButtonClick}
            after={shouldUseDropdown && <ArrowFull />}
        >
            <Text variant="t80">Meet</Text>
        </MainButton>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        meetButton: {
            backgroundColor: theme.customization.interactive.C10,
            '& div': {
                display: 'flex',
                alignItems: 'center',
            },
            '&:hover': {
                backgroundColor: theme.customization.interactive.C20,
            },
        },
        disabled: {
            cursor: 'default',
            backgroundColor: theme.palette.greys[400],
            '&:hover': {
                backgroundColor: theme.palette.greys[400],
            },
        },
    }),
    { classNamePrefix: 'meet-main-button' }
);

export default MeetMainButton;
